const maximize = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M4.747 12.313 7.43 15H1V8.56l2.688 2.692 7.564-7.564L8.56 1H15v6.43l-2.687-2.683z"/></svg>',
};

export { maximize as default };
